<script lang="ts">
    import ColumnsColumn from "./Columns_Column.svelte"

    export let block: ContentBlockEntry
</script>

<div class="container">
    <div class="grid">
        {#each block.columns as column}
            <ColumnsColumn {column} />
        {/each}
    </div>
</div>
